import { render, staticRenderFns } from "./flow_approve.vue?vue&type=template&id=2cd1ef9e&scoped=true"
import script from "./flow_approve.vue?vue&type=script&lang=js"
export * from "./flow_approve.vue?vue&type=script&lang=js"
import style0 from "./flow_approve.vue?vue&type=style&index=0&id=2cd1ef9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1ef9e",
  null
  
)

export default component.exports